export enum VariationTypeEnum {
    NONE = 'none',
    SIZE = 'size',
    COLOR = 'color',
    BOTH = 'both',
}